import { Button } from "@/components/ui/button";

interface CarouselPaginationProps {
  currentSlide: number;
  totalSlides: number;
  onDotClick: (index: number) => void;
}

export const CarouselPagination = ({ 
  currentSlide, 
  totalSlides, 
  onDotClick 
}: CarouselPaginationProps) => {
  return (
    <div className="flex flex-col items-center gap-3 mt-4">
      {/* Count indicator */}
      <div 
        className="text-sm text-muted-foreground"
        aria-live="polite"
        aria-label={`Slide ${currentSlide + 1} of ${totalSlides}`}
      >
        {currentSlide + 1} of {totalSlides}
      </div>
      
      {/* Dots */}
      <div className="flex gap-2" role="tablist" aria-label="Industry carousel navigation">
        {Array.from({ length: totalSlides }, (_, index) => (
          <Button
            key={index}
            variant="ghost"
            size="sm"
            className={`w-3 h-3 rounded-full p-0 ${
              index === currentSlide 
                ? 'bg-primary' 
                : 'bg-muted hover:bg-muted-foreground/20'
            }`}
            onClick={() => onDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
            role="tab"
            aria-selected={index === currentSlide}
          >
            <span className="sr-only">Slide {index + 1}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};